(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('NativeLanguageDialogController', NativeLanguageDialogController);

    NativeLanguageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NativeLanguage'];

    function NativeLanguageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NativeLanguage) {
        var vm = this;
        vm.nativeLanguage = entity;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:nativeLanguageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.nativeLanguage.id !== null) {
                NativeLanguage.update(vm.nativeLanguage, onSaveSuccess, onSaveError);
            } else {
                NativeLanguage.save(vm.nativeLanguage, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
